import { ConfigurationError } from '@cian/peperrors/shared';

import { AssetsStorage } from '../browser/internal/assets/AssetsStorage.js';
import { DOMAssetLoader } from '../browser/internal/assets/domLoader.js';
import { CianMFUIElement } from '../browser/internal/cianMFUI/index.js';
import { Registry } from '../browser/internal/registry/index.js';
import { EAssetType, type IFileAsset, type IInlineAsset, type IModuleAsset } from '../shared/assets/index.js';
import { CIAN_MF_UI_ELEMENT_NAME } from '../shared/cianMFUI/constants.js';
import {
  WINDOW_ASSETS_STORAGE_CONST,
  WINDOW_MANIFEST_CONST,
  WINDOW_REGISTRY_CONST,
} from '../shared/constants/index.js';

import type { IRegistryManifest, IRegistryMicrofrontendManifest } from '../shared/manifest/index.js';

function init() {
  if (window[WINDOW_REGISTRY_CONST]?.v1) {
    throw new ConfigurationError({
      message: 'Реестр микрофронтендов уже инициализирован',
      domain: 'mf-registry.cdn.init',
    });
  }

  const assetsStorage = initAssets(window[WINDOW_MANIFEST_CONST]);

  window[WINDOW_REGISTRY_CONST] = { v1: new Registry(window[WINDOW_MANIFEST_CONST], assetsStorage) };

  customElements.define(CIAN_MF_UI_ELEMENT_NAME, CianMFUIElement);
}

init();

function initAssets(manifest?: IRegistryManifest): AssetsStorage {
  if (window[WINDOW_ASSETS_STORAGE_CONST]) {
    return window[WINDOW_ASSETS_STORAGE_CONST] as AssetsStorage;
  }

  const ssrAssets: Map<string, IFileAsset | IInlineAsset | IModuleAsset> = new Map();

  if (manifest?.microfrontends) {
    for (const microfrontend of Object.values(manifest.microfrontends)) {
      for (const asset of assetsIterator(microfrontend)) {
        if (asset.type === EAssetType.File) {
          ssrAssets.set(asset.src, asset);
        } else {
          ssrAssets.set(asset.hash, asset);
        }
      }
    }
  }

  const domLoader = new DOMAssetLoader();

  window[WINDOW_ASSETS_STORAGE_CONST] = new AssetsStorage(domLoader, ssrAssets.values());

  return window[WINDOW_ASSETS_STORAGE_CONST] as AssetsStorage;
}

function* assetsIterator(
  manifest: IRegistryMicrofrontendManifest,
): IterableIterator<IFileAsset | IInlineAsset | IModuleAsset> {
  if (manifest.images) {
    for (const { assets } of Object.values(manifest.images)) {
      for (const asset of Object.values(assets)) {
        yield asset;
      }
    }
  }
}
